import React from 'react'
import { Box, Typography, SvgIcon } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Button from '@hapana/shared/web/components/shared/button/button.component'
import LockAccessIcon from '@hapana/shared/web/styles/assets/svgs/lock-access.svg'
import { commonStyles } from '@hapana/shared/web/styles/common.styles'

import { styles } from './access-denied.styles'

import { ROUTES } from '../../app.constants'

const AccessDenied = ({ rootStyle, children }) => {
  const root = rootStyle ?? styles.root

  const navigate = useNavigate()
  const { t } = useTranslation('core')
  return (
    <Box sx={[root, commonStyles.fullWidth]}>
      <Box sx={styles.accessDeniedContainer}>
        <Box sx={styles.iconContainer}>
          <SvgIcon sx={styles.icon} component={LockAccessIcon} />
        </Box>
        <Typography typography="header1" color="gray.64">
          {t('accessDenied.title')}
        </Typography>
        <Typography typography="large" color="gray.64" sx={styles.description}>
          {t('accessDenied.description')}
        </Typography>
        {children ?? (
          <Button
            label={t('accessDenied.buttonLabel')}
            onClick={() => navigate(ROUTES.login.path)}
            data-testid="access-denied-button-label"
          />
        )}
      </Box>
    </Box>
  )
}

export default AccessDenied

AccessDenied.propTypes = {
  rootStyle: PropTypes.object,
  children: PropTypes.node,
}
